import { Container, Grid, Typography, Box, Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import DatabricksBanner from "../../asset/images/databricks/banner/databricks-banner.webp";
import AutomatingQlik from "../../asset/images/insight/case_studies/case_studies_thumbnails/automating-qlik-to-databricks.webp";
import LoanServicer from "../../asset/images/insight/case_studies/case_studies_thumbnails/optimized-loan-servicer-onboarding.webp"; 

import processing1 from "../../asset/images/databricks/applications/processing1.webp"; 
import processing2 from "../../asset/images/databricks/applications/processing2.webp"; 
import processing3 from "../../asset/images/databricks/applications/processing3.webp"; 

import processing4 from "../../asset/images/databricks/applications/processing4.webp"; 
import processing5 from "../../asset/images/databricks/applications/processing6.webp"; 
import processing6 from "../../asset/images/databricks/applications/processing5.webp"; 

import adv1 from "../../asset/images/databricks/applications/advisory.webp";
import adv2 from "../../asset/images/databricks/applications/embedded.webp";
import adv3 from "../../asset/images/databricks/applications/future.webp";
import adv4 from "../../asset/images/databricks/applications/measurable.webp";

import DatabricksContactUs from '../../Component/forms/DatabricksContactUs'; 


export default function Databricks() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    // Scroll to form started
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const stickyItemsHeight = 30;
            const offset = element.getBoundingClientRect().top - stickyItemsHeight;


            setTimeout(() => {
                window.scrollBy({ top: offset, behavior: 'smooth' });
            }, 50);
        }
    };

    useEffect(() => {
        const { hash } = window.location;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                const offset = 50;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition - offset;
                window.scrollBy({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    }, []);
    // Scroll to form ended

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title> Smarter Data Intelligence | Databricks Partnership </title>
                <meta name="description" content="Explore the powerful partnership between Decimal Point Analytics & Databricks delivering data intelligence to modernize, optimize & scale with impact. Read now!" />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/databricks" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>

            <Box id="headingdbricks">
                <Box id="new_landing_carousel" className='ibmbanner'>
                    <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + DatabricksBanner + ")" }} pb={2}>
                        <Container maxWidth="lg">
                            <Grid container spacing={1} alignItems="center" justifyContent='center'>
                                <Grid item lg={9} md={12} sm={11} xs={10}>
                                    <Box className="text_animated mb0">
                                        <Typography variant="h1" className="blue fw6 mb0" gutterBottom>
                                            Expert Databricks Implementation <span className='lower'>for</span> Your Data & AI Goals
                                        </Typography>

                                        <Box>
                                            <Typography variant="h2" className="black3" gutterBottom>
                                                <span className='fw4'>Decimal Point Analytics <span className='lower'>partners with</span> <strong>Databricks</strong> <span className='lower'>to help enterprises reduce costs, accelerate innovation, and mitigate risks-all on one open, governed platform.</span> </span>
                                            </Typography>
                                        </Box>

                                        <Box mt={2}>
                                            <Link to="/databricks#databrickscontactus" onClick={() => scrollToElement('databrickscontactus')}>
                                                <Button variant="contained" className='dpabtn_sm1'>
                                                    Talk to Our Experts
                                                </Button>
                                            </Link>
                                        </Box>

                                    </Box>
                                </Grid>

                            </Grid>
                        </Container>
                    </Box>
                </Box>
            </Box>
            <Box id='sba_solutions' className='section mob_card databricks_card' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={3} alignItems="center" justifyContent='center'>

                        <Grid container spacing={1} alignItems="top">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='al_center' mb={3} mx={2}>
                                    <Typography variant='h2' className='black'>
                                        DPA + Databricks – The Power of Data Intelligence
                                    </Typography>
                                    <Typography variant='h6' className='black mb0' gutterBottom>
                                        At Decimal Point Analytics, we partner with <strong>Databricks</strong> to deliver the <strong>Data Intelligence Platform,</strong> unifying analytics, AI, and governance on a single Lakehouse architecture. Together, we help organizations:
                                    </Typography>
                                </Box>

                            </Grid>
                        </Grid>


                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties br_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing4} className='allic' alt='Autonomy and Self-Management' />
                                </Box>
                                <Box mt={2} mb={2}>
                                    <Typography variant="h6" className="black al_center">
                                        <strong>Eliminate silos</strong> with a single copy of data for all workloads (BI, SQL, ML, and GenAI).
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties br_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing5} className='allic' alt='Performance Acceleration' />
                                </Box>
                                <Box mt={2} mb={2}>
                                    <Typography variant="h6" className="black al_center">
                                        <strong>Democratize AI</strong> with Mosaic AI, Unity Catalog, and low-code tools for non-technical users.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties br_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing6} className='allic' alt='Security Fortification' />
                                </Box>
                                <Box mt={2} mb={2}>
                                    <Typography variant="h6" className="black al_center">
                                        <strong>Reduce TCO</strong> by up to <strong>8x</strong> compared to legacy data warehouses.
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className="al_center">
                                <Typography variant='h6' className='black mb0' gutterBottom>
                                    <i>"It’s not just about data—it’s about actionable intelligence."</i>
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section mob_card sec_bg databricks_card_sec' component='section'>
                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className='al_center'>
                                <Typography variant='h2' className='black'>
                                    DPA’s Databricks Competencies
                                </Typography>

                            </Box>

                        </Grid>
                    </Grid>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ibm_experties boxbg minht">
                                <Box className='ora_iconbx al_left'>
                                    <img loading="lazy" src={processing1} className='allic' alt='End-to-End Support' />
                                </Box>
                                <Box my={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom> Lakehouse Deployment </Typography>
                                    <Typography variant="h6" className="black al_left mb0" gutterBottom>
                                        Migrate from legacy warehouses (Snowflake, Redshift) to Databricks with zero downtime.
                                    </Typography>
                                    <Typography variant="h6" className="black al_left mb0">
                                        <strong>Example:</strong>
                                    </Typography>
                                    <Typography variant="h6" className="black al_left mb0">
                                        Migrating multiple data sets across diverse systems to Databricks and set up
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ibm_experties boxbg minht">
                                <Box className='ora_iconbx al_left'>
                                    <img loading="lazy" src={processing2} className='allic' alt='Proven Expertise' />
                                </Box>
                                <Box my={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom> Maximizing Performance </Typography>
                                    <Typography variant="h6" className="black al_left mb0" gutterBottom>
                                        Reduce latency, improve job execution speed via superior system design
                                    </Typography>
                                    <Typography variant="h6" className="black al_left mb0">
                                        <strong>Example:</strong>
                                    </Typography>
                                    <Typography variant="h6" className="black al_left mb0">
                                        Improved data onboarding time by 30% for a client by normalizing schemas and automating data ingestion
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ibm_experties boxbg minht">
                                <Box className='ora_iconbx al_left'>
                                    <img loading="lazy" src={processing3} className='allic' alt='Advanced Technology' />
                                </Box>
                                <Box my={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom> Managed Services  </Typography>
                                    <Typography variant="h6" className="black al_left mb0" gutterBottom>
                                        24/7 platform management, performance tuning, and user support
                                    </Typography>
                                    <Typography variant="h6" className="black al_left mb0">
                                        <strong>Example:</strong>
                                    </Typography>
                                    <Typography variant="h6" className="black al_left mb0">
                                        Achieved 99.9% uptime for a large alternative asset manager with 24/7 monitoring
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className="al_center">
                                <Typography variant='h6' className='black mb0' gutterBottom>
                                    Want to explore how our Databricks services can optimize your data operations? <Link to="/contact-us#contact_form" className="link">Connect with us</Link>.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={3} alignItems="center" justifyContent='left'>

                        <Grid container spacing={1} alignItems="top">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='al_center'>
                                    <Typography variant='h2' className='black mb0'>
                                        The Decimal Point Difference
                                    </Typography>
                                    <Typography variant='h6' className='black al_center'>
                                        Decimal Point brings a result based solution approach
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>


                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv1} className='allic' alt='Advisory-First Implementation' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom> Advisory-First Implementation </Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        We start by aligning Databricks’ capabilities to your KPIs—not just pushing technology.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv2} className='allic' alt='Embedded Teams' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Embedded Teams</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Our engineers work alongside yours to transfer knowledge (Agile sprints, co-development).
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv3} className='allic' alt='Future-Proof Scaling' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom> Future-Proof Scaling </Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Design for tomorrow: Multi-cloud readiness, GenAI pipelines, and real-time analytics.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv4} className='allic' alt='Measurable Outcomes' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Measurable Outcomes </Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Track success with predefined metrics (e.g., 50% faster queries, 30% lower cloud spend).
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box>



            <Box id='sba_solutions' className="section sec_bg" component="section">
                <Container maxWidth="lg" className="bdr">
                    <Grid container spacing={2} alignItems="center" justifyContent='center'>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className="al_center">
                                <Typography variant="h2" className="black">
                                    Real-World Success Stories
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className='reportinfo'>
                                <Box className="reportm_bg">
                                    <Box
                                        className="reportimg_bg"
                                        style={{
                                            backgroundImage: 'url(' + LoanServicer + ')',
                                        }}
                                    >
                                        <Button variant="contained" className='ora_title_btn'>
                                            Case Study
                                        </Button>
                                    </Box>

                                    <Box my={2}>
                                        <Typography className="reporttitle two" title="Optimized Loan Servicer Onboarding with Databricks Architecture">
                                            Optimized Loan Servicer Onboarding with Databricks Architecture
                                        </Typography>
                                    </Box>
                                    <Box className="line" mb={2}></Box>

                                    <Typography variant="h6" className="black al_left jst thr" title="A US asset manager reduced onboarding delays and improved data efficiency using Databricks-powered architecture with structured templates and fast processing.">
                                        A US asset manager reduced onboarding delays and improved data efficiency using Databricks-powered architecture with structured templates and fast processing.
                                    </Typography>

                                    <Box mt={2}>
                                        <Link to="/case-study/servicer-onboarding-databricks-architecture" className="link">
                                            <Button variant="contained" className='dpabtn_sm1' endIcon={<NavigateNextIcon />}>
                                                Read More
                                            </Button>
                                        </Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className='reportinfo'>
                                <Box className="reportm_bg">
                                    <Box
                                        className="reportimg_bg"
                                        style={{
                                            backgroundImage: 'url(' + AutomatingQlik + ')',
                                        }}
                                    >
                                        <Button variant="contained" className='ora_title_btn'>
                                            Case Study
                                        </Button>
                                    </Box>

                                    <Box my={2}>
                                        <Typography className="reporttitle two" title="Automating Qlik-to-Databricks Migration with Real-Time Insight">
                                            Automating Qlik-to-Databricks Migration with Real-Time Insight
                                        </Typography>
                                    </Box>
                                    <Box className="line" mb={2}></Box>


                                    <Typography variant="h6" className="black al_left jst thr" title="Enabled real-time monitoring and automated migration from Qlik to Databricks - reduced onboarding time, errors and enhanced data reliability.">
                                        Enabled real-time monitoring and automated migration from Qlik to Databricks - reduced onboarding time, errors and enhanced data reliability.
                                    </Typography>

                                    <Box mt={2}>
                                        <Link to="/case-study/qlik-databricks-migration-automation" className="link">
                                            <Button variant="contained" className='dpabtn_sm1' endIcon={<NavigateNextIcon />}>
                                                Read More
                                            </Button>
                                        </Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box >

            <Box id='databrickscontactus'>
                <DatabricksContactUs />
            </Box>

        </>
    );
}
